import { html, LitElement } from 'lit';
import { FontSizes, LineHeights } from '../../../../../types/common/types';
import { translateFn } from '../../../../../utils/translator.helper';
import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_RUN_NETWORK_DISCOVERY } from '../../../../../webcomponents.constants';
import { styles } from './view/styles';

@customElement(WEB_COMPONENT_RUN_NETWORK_DISCOVERY)
export class GzRunNetworkDiscoveryWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  protected render() {
    return html`
      <gz-text lineHeight="${LineHeights.SMALL}" fontSize="${FontSizes.HEADING_6}">
        ${translateFn('You are about to create a task that will automatically detect endpoints in your network.')}
      </gz-text>
    `;
  }
}
